import { createEventDispatcher } from 'svelte';

export const initEventDispatcher = (
  component
) => {
  const svelteDispatch = createEventDispatcher();

  return (name, detail) => {
    svelteDispatch(name, detail);
    component.dispatchEvent &&
      component.dispatchEvent(new CustomEvent(name, { detail }));
  };
};
